import{DEFAULT_ALGOLIA_HIERARCHY_DIVIDER as r}from"@danfoss-source/search";const t=(t,s,e=r)=>{const o=`${s}${e}`;return t.filter((({value:r})=>r.startsWith(o))).map((({value:r})=>r))};export{t as getSelectedSubcategories};
